import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../../locales/contact-form/en.json";
import de from "../../locales/contact-form/de.json";
import { getLocale } from "../../utils/apiSettings";

const resources = {
  en: { translation: en },
  de: { translation: de },
};

const locale = getLocale();
let lng = "en";
switch (locale) {
  case "de-DE":
    lng = "de";
    break;
}

i18n.use(initReactI18next).init({
  resources,
  lng,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // React already does escaping
  },
});
